module.exports = __webpack_public_path__ + "static/media/ramenswap.4f40310e.png";